import Heading from 'LearningManager/components/Heading';
import styles from 'LearningManager/styles/CustomSetup.module.scss';
import CheckBoxCard from 'LearningManager/components/CheckBoxCard';
import { Icon, Input } from 'Components';
import classNames from 'classnames';
import { useStepper } from 'LearningManager/hooks/Stepper.context';

interface OptionsProps {
	id: number;
	title: string;
	desc: string;
}

const options: OptionsProps[] = [
	{
		id: 1,
		title: 'Pyramid Hotel',
		desc: '200 users'
	},
	{
		id: 2,
		title: 'Marriott Hotel',
		desc: '250 users'
	},
	{
		id: 3,
		title: 'Grand Plaza',
		desc: '180 users'
	},
	{
		id: 4,
		title: 'Ocean View Resort',
		desc: '300 users'
	}
];

const Property = () => {
	const {
		draft: {
			customSetup: { selectedPropertyIds }
		},
		toggleAssignUsersSelection,
		setAssignUsersSelection
	} = useStepper();

	const handleCheckboxChange = (id: number, checked: boolean) => {
		if (checked !== selectedPropertyIds.includes(id)) {
			toggleAssignUsersSelection('selectedPropertyIds', id);
		}
	};

	const handleSelectAll = () => {
		if (selectedPropertyIds.length === options.length) {
			setAssignUsersSelection('selectedPropertyIds', []);
		} else {
			setAssignUsersSelection(
				'selectedPropertyIds',
				options.map((opt) => opt.id)
			);
		}
	};

	const isAllSelected = selectedPropertyIds.length === options.length;

	return (
		<div id="lms-ca-assign-users-property">
			<div
				className={classNames(
					styles.filters,
					styles['filters--flex_end']
				)}
			>
				<Input.Search
					id="lms-ca-au-property-search"
					className={styles.search}
					placeholder="Search"
					suffix={<Icon type="search" role="img" />}
				/>
			</div>
			<div className={styles.header}>
				<Heading
					titleClassName={styles.title}
					title="Select Property"
				/>
				{options.length > 1 && (
					<div
						id="lms-ca-au-property-select-all"
						className={styles.selectAllBtn}
						onClick={handleSelectAll}
					>
						{isAllSelected ? 'Deselect all' : 'Select all'}
					</div>
				)}
			</div>
			<div id="lms-ca-au-property-list" className={styles.container}>
				{options.map((option) => (
					<CheckBoxCard
						key={option.id}
						id={option.id}
						htmlId={`lms-ca-au-property-${option.id}`}
						icon={<Icon type="propOptIcon" />}
						title={option.title}
						desc={option.desc}
						isChecked={selectedPropertyIds.includes(option.id)}
						onChange={handleCheckboxChange}
					/>
				))}
			</div>
		</div>
	);
};

export default Property;
